import React from "react";

export default function CareersFooter() {
  return (
    <div className="careers-footer">
      <div className="careers-footer-policy">
        <p>
          WebstaurantStore provides equal employment opportunity without regard
          to race, color, sex, age, handicap, religion, national origin, marital
          status, sexual orientation, physical disability or veteran status.
          Reasonable accommodations will be made to qualified individuals who
          are covered under the Americans with Disabilities Act (ADA). This
          applies to all areas of employment, recruitment, hiring, training and
          development, promotion, transfer, termination, layoff, compensation,
          and all other conditions and privileges of employment in accordance
          with applicable federal, state, and local laws. We are fully committed
          to this concept and to obtaining the cooperation and understanding of
          this effort by all our employees.
        </p>
      </div>
      <div className="careers-footer-copyright">
        &copy; {new Date().getFullYear()} The WEBstaurant Store, LLC - All
        Rights Reserved.
      </div>
      <a href="/" className="careers-footer-logo" target="_blank">
        <img
          src="//cdnimg.webstaurantstore.com/uploads/design/2017/2/webstaurantstore-logo-careers.png"
          alt=""
          className="careers-footer__logo"
        />
      </a>
    </div>
  );
}
